export interface Testimonial {
  name: string;
  role: string;
  avatar: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: '风影绘师·佐',
    role: 'Pixiv人气绘师 / Fanbox创作者',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20artist%20portrait%20avatar%2C%20creative%20expression%2C%20warm%20tone%2C%20clean%20background&width=100&height=100&seq=testimonial-avatar-01&orientation=squarish',
    content: '作为火影同人圈的老绘师，这个导航站帮了大忙。以前找参考资料要翻好几个平台，现在一站式就能搞定，创作效率提升了不少。分类特别清晰，新入圈的绘师强烈推荐！',
    rating: 5,
  },
  {
    name: '木叶观察者',
    role: '同人文化研究者 / 资深爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20researcher%20avatar%2C%20intellectual%20look%2C%20warm%20smile%2C%20clean%20portrait&width=100&height=100&seq=testimonial-avatar-02&orientation=squarish',
    content: '社区资讯更新非常及时，Comiket新刊速递和绘师动态追踪做得很好。文章质量也高，角色分析和文化解读都很有深度，不是那种敷衍的搬运内容。',
    rating: 5,
  },
  {
    name: '晓のアーティスト',
    role: '同人社团主笔 / DLsite创作者',
    avatar: 'https://readdy.ai/api/search-image?query=Manga%20style%20artist%20avatar%20with%20dark%20aesthetic%2C%20cool%20expression%2C%20professional%20portrait%2C%20warm%20tone&width=100&height=100&seq=testimonial-avatar-03&orientation=squarish',
    content: '付费平台对比那篇文章太实用了！我之前在Fanbox和Fantia之间纠结了好久，看了对比分析后立刻明确了方向。现在月收入翻了一倍，真心感谢！',
    rating: 5,
  },
  {
    name: 'サスケのファン',
    role: '火影同人10年老粉',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20fan%20portrait%20avatar%2C%20enthusiastic%20expression%2C%20casual%20style%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=testimonial-avatar-04&orientation=squarish',
    content: '从贴吧时代追到现在，眼看着火影同人圈起起落落。这个站让我重新找到了组织的感觉，资源导航太全了，连一些冷门平台都有收录。希望越做越好！',
    rating: 4,
  },
];